import { PdfGen, PdfUnit, PdfSize, PdfPoint, PdfRect, PdfBrush, ETextAlign } from '../../pdf/pdf';
import { ILayoutMultiGen } from '../layoutMulti';
import { OptsMulti } from '../optsMulti';
import { GUtil } from '../../pdf/gutil';
import { genMulti } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/barcode';

import { IItemCount } from '@educraft/base';

/**
 * QR (QR Code Exercise)
 *
 * Layout: Landscape strips; question text on left, QR code of answer on right.
 *
 * Migrated from C# EduFrame.Multi.Generators.QR
 */
export class QR implements ILayoutMultiGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsMulti): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const countPerPage = 5;
    const totalCount = this.countDefault();
    const size = new PdfSize(PdfSize.A4.width, PdfSize.A4.height / countPerPage);

    for (let i = 0; i < totalCount; i += countPerPage) {
      const page = pdf.addPage();
      const count = Math.min(countPerPage, totalCount - i);
      const gen = genMulti(opts.data, opts.generator, count, true, false);

      for (let j = 0; j < gen.length; j++) {
        const rect = new PdfRect(0, j * size.height, size.width, size.height);
        const qr = new PdfRect(
          rect.right - rect.height + margin,
          rect.top + margin,
          rect.height - 2 * margin,
          rect.height - 2 * margin
        );
        const textRect = new PdfRect(
          rect.left + margin,
          rect.top + margin,
          rect.width - rect.height - margin,
          rect.height - 2 * margin
        );

        // Combine question texts and answer options
        const texts = [
          ...gen[j].texts,
          ...gen[j].answers.map((a, k) => `${String.fromCharCode(97 + k)}) ${a}`),
        ];

        const f = page.adjustFont(textRect.width, texts, GUtil.baseFont);

        page.drawRectangle(GUtil.cutPen, null, rect);
        page.drawStrings(texts, f, PdfBrush.Black, null, textRect, ETextAlign.CenterLeft);

        // Draw QR code with the correct answer
        const answer = gen[j].answers[gen[j].answerIndex];
        page.drawQr(qr, PdfBrush.Black, answer);
      }
    }
  }
}
